export default __webpack_public_path__ + "static/media/myexpertbg.ad3f6214.svg";